class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartDrawer = document.querySelector('cart-drawer')

      if (this.dataset.bundle) {
        const itemsInBundle = cartDrawer.querySelectorAll(`cart-drawer-remove-button[data-bundle="${this.dataset.bundle}"]`)
        let quantityChanges = {}

        for (let item of itemsInBundle) {
          const itemKey = item.dataset.key
          quantityChanges[itemKey] = 0
        }
        
        cartDrawer.enableLoading();

        const body = JSON.stringify({
          updates: quantityChanges,
          sections: cartDrawer.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
    
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            cartDrawer.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                
              elementToReplace.innerHTML =
              cartDrawer.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));

            cartDrawer.disableLoading();

            function setCookie(name, value, days) {
              var expires = "";
              if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
              }
              document.cookie = name + "=" + (value || "") + expires + "; path=/";
            }
            
            function getCookie(name) {
              var nameEQ = name + "=";
              var ca = document.cookie.split(';');
              for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
              }
              return null;
            }

            $.ajax({
              type: 'GET',
              url: '/cart.js',
              cache: false,
              dataType: 'json',
              success: function(cart) {
                console.log(cart.total_price)
               if(cart.total_price >= 15000) {
                 setCookie('overAmount', 'true', 1)
               } else {
                 setCookie('overAmount', 'false', 1)
               }
              }
            });
          
          }).catch((error) => {
            cartDrawer.disableLoading();
            console.log(error);
          });
        
      } else {
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0, '', this.dataset.removeNote)
      }
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.drawer = document.getElementById('cart-drawer');
    this.form = document.querySelector('form');
    this.pageOverlayElement = document.querySelector('.page-overlay');
    
    // Open cart
    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));

    // Close Cart
    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.shippingThreshold = Number(this.dataset.shipping);
    this.shippingThresholdText = this.querySelector('#threshold-text');
    this.shippingBar = this.querySelector('.cart-drawer__threshold-bar-inner');

    // On Change
    this.debouncedOnChange = debounce((event) => {
      if (!event.target.closest('gift-slideout')) {
        this.onChange(event);
      }
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // Open Gift slideout
    this.drawer.addEventListener('click', event => {
      const button = event.target.closest('.cart-drawer__gift-button');
      
      if (button) {
        event.preventDefault();
        document.querySelector('gift-slideout').open();
      }
    });
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);

    document.body.classList.add('scroll-lock');
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);

    document.body.classList.remove('scroll-lock');
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name, removeNote) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateValues(parsedState);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.disableLoading();

       function setCookie(name, value, days) {
          var expires = "";
          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }
        
        function getCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
          }
          return null;
        }

       $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function(cart) {
            console.log(cart.total_price)
           if(cart.total_price >= 15000) {
             setCookie('overAmount', 'true', 1)
           } else {
             setCookie('overAmount', 'false', 1)
           }
          }
        });
      }).catch(() => {
        this.disableLoading();
      }).finally(() => {
        if (removeNote != undefined) {
          this.removeNote();
        }
      });
  }

  rerender(openCart) {
    this.enableLoading();

    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateValues(parsedState);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.disableLoading();

       function setCookie(name, value, days) {
          var expires = "";
          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }
        
        function getCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
          }
          return null;
        }

        $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function(cart) {
            console.log(cart.total_price)
           if(cart.total_price >= 15000) {
             setCookie('overAmount', 'true', 1)
           } else {
             setCookie('overAmount', 'false', 1)
           }
          }
        });
      }).catch(() => {
        this.disableLoading();
      }).finally(() => {
        if (openCart) {
          this.open();
        }
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: 'cart-drawer',
        selector: '.cart-drawer__content',
      },
      {
        id: 'shipping-threshold',
        section: 'cart-drawer',
        selector: '.cart-drawer__threshold',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer__footer',
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  removeNote() {
    const body = JSON.stringify({
      note: ''
    });

    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then(() => {
        // Uncheck checkboxes
        this.querySelector('input[type="checkbox"]').checked = false;

        // Enable form
        this.querySelector('.gift-form__input-wrapper').classList.remove('disabled');

        // Clear message
        this.querySelector('.gift-form__message').value = '';

      }).catch((error) => {
        console.error(error);
      });
  }

  updateValues(cart) {
    // Cart Count in header
    const cartCountEl = this.querySelector('#cart-drawer__title-count');
    cartCountEl.innerHTML = cart.item_count;

    // Shipping Threshold
    // if (this.shippingThreshold) {
    //   const newShippingThreshold = this.getSectionInnerHTML(cart.sections['cart-drawer'], '#threshold-text')
    //   this.shippingThresholdText.innerHTML = newShippingThreshold;

    //   // Bar
    //   if (this.shippingThreshold > cart.items_subtotal_price) {
    //     const shippingBarWidth = (cart.items_subtotal_price / this.shippingThreshold) * 100;
    //     this.shippingBar.style.width = `${shippingBarWidth}%`;
    //   } else {
    //     this.shippingBar.style.width = '100%';
    //   }
    //   setTimeout(function(){
    //   console.log('Cart Rebuy Init');
    //   Rebuy.init(); 
    //   }, 700);
    //   document.addEventListener('rebuy.change', function(event){
    //     console.log('rebuy.change');
    //     Rebuy.init();
    //   });
    //   document.addEventListener('rebuy.ready', function(event){
    //     console.log('rebuy.ready');
    //     Rebuy.init();
    //   });
    //   // Rebuy.init();
    // }
  }

  enableLoading() {
    const loadingEl = document.getElementById('cart-drawer-loading');
    if (loadingEl) {
      loadingEl.classList.remove('hidden');
    }
  }

  disableLoading() {
    const loadingEl = document.getElementById('cart-drawer-loading');
    if (loadingEl) {
      loadingEl.classList.add('hidden');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);



class GiftSlideout extends HTMLElement {
  constructor() {
    super();
    
    this.drawer = document.querySelector('.gift-slideout');
    this.closeButtons = document.querySelectorAll('.gift-slideout__close');
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.drawer.classList.add('active');
  }

  close() {
    this.drawer.classList.remove('active');
  }
}

customElements.define('gift-slideout', GiftSlideout);
